import { useEffect, useState } from 'react'
import type { Freshness } from './queueFreshness'
import './queue-freshness.css'

/** Cat de veche e coada si ce s-a schimbat de la ultima privire, langa filtrul de stare. */
export function QueueFreshnessBar({ updatedAt, fresh, onMarkSeen }: { updatedAt: number; fresh: Map<number, Freshness>; onMarkSeen(): void }) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 10_000)
    return () => window.clearInterval(timer)
  }, [])

  const created = [...fresh.values()].filter((f) => f === 'new').length
  const grown = fresh.size - created
  const parts = [created > 0 ? `${created} new` : '', grown > 0 ? `${grown} updated` : ''].filter((p) => p !== '')

  return (
    <span className="incident-freshness" aria-live="polite">
      {updatedAt > 0 && <span className="incident-freshness-age">Updated {age(now - updatedAt)}</span>}
      {parts.length > 0 && (
        <>
          <span className="incident-freshness-count">{parts.join(' · ')}</span>
          <button type="button" className="btn btn-xs btn-link incident-mark-seen" onClick={onMarkSeen}>
            Mark all seen
          </button>
        </>
      )}
    </span>
  )
}

function age(ms: number): string {
  const seconds = Math.max(0, Math.round(ms / 1000))
  if (seconds < 60) return seconds < 10 ? 'just now' : `${Math.floor(seconds / 10) * 10}s ago`
  return `${Math.floor(seconds / 60)} min ago`
}
